import { useLocation } from 'react-router-dom';
import { CLAIM_ID_QUERY_LABEL } from 'constants/commonConstants';
import fileDownload from 'js-file-download';
import { PrivacyNoticeRoute, TermsOfUseRoute } from 'constants/routes';
import { RolePermissions, UserProfile } from 'containers/Security/modules/types';
import { PERMISSIONS, ROLES } from 'containers/Security/modules/enums';

export async function downloadDocument(response: any, fileName: string) {
  const blob = await response.blob();
  fileDownload(new File([blob], fileName), fileName);
}

export function getUrlParams() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params;
}

export function generateURL(hashes) {
  // todo: use URLSearchParams
  let str = '';

  if (hashes[CLAIM_ID_QUERY_LABEL]) str += `?claimId=${hashes[CLAIM_ID_QUERY_LABEL]}`;
  return str;
}

export function appendParams(searchParams) {
  const params = new URLSearchParams();
  searchParams.forEach((element) => {
    params.append(element.label, element.value);
  });

  return params;
}

export function removeParams(param) {
  const params = new URLSearchParams();
  params.delete(param);

  return params;
}

export const isPathNotices = (path) => {
  if (path === PrivacyNoticeRoute || TermsOfUseRoute) {
    return true;
  } else {
    return false;
  }
};

export const checkIsOnlyStandardUserRole = (user: UserProfile) => {
  return (
    user.permissions.length === 1 &&
    user.permissions.map((perm) => perm.role).includes(ROLES.STANDARD_USER)
  );
};

export const checkHasAdminUserRole = (user: UserProfile) => {
  return user.permissions.map((perm) => perm.role).includes(ROLES.ADMIN_USER);
};

export const userHasPermission = (permission: PERMISSIONS, userPermissions: RolePermissions[]) => {
  return (
    userPermissions.some((rp) => {
      return rp?.permissions.includes(permission);
    }) ?? false
  );
};

export const toTitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
